//#region src/js/utils/youtubeModals.js
const youtubeModals = () => {
	const links = document.querySelectorAll(["a[href*=\"youtube.com\"]", "a[href*=\"youtu.be\"]"].join(","));
	if (links.length > 0) {
		links.forEach((link) => {
			const urlObj = new URL(link.getAttribute("href"));
			let videoId = false;
			if (urlObj.host === "youtu.be") videoId = urlObj.pathname.replace("/", "");
			else videoId = urlObj.searchParams.get("v");
			if (videoId) {
				const template = `
          <div class="modal-box w-full max-w-4/5 p-4">
            <iframe
              title="YouTube video player"
              class="yt-${videoId} w-full h-auto aspect-video"
              data-src="https://www.youtube.com/embed/${videoId}?autoplay=true&rel=0"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              loading="lazy"
            ></iframe>
          </div>
        `.trim();
				const dialog = document.createElement("dialog");
				dialog.setAttribute("id", `yt-${videoId}`);
				dialog.setAttribute("closedby", "any");
				["modal"].map((c) => dialog.classList.add(c));
				dialog.innerHTML = template;
				document.querySelector("body").appendChild(dialog);
				link.addEventListener("click", (event) => {
					const targetDialog = document.querySelector(`#yt-${videoId}`);
					targetDialog.showModal();
					const targetVideo = targetDialog.querySelector("iframe");
					targetVideo.setAttribute("src", targetVideo.dataset.src);
					event.preventDefault();
				});
			}
		});
		document.querySelectorAll("dialog[id^=\"yt-\"]").forEach((overlay) => {
			overlay.addEventListener("click", (event) => {
				document.querySelector(`#${overlay.id}`).close();
				event.preventDefault();
			});
			overlay.addEventListener("close", () => {
				document.querySelector(`iframe.${overlay.id}`).removeAttribute("src");
			});
		});
	}
};
if (window.youtubeModalOverlay) document.addEventListener("DOMContentLoaded", youtubeModals);
//#endregion
//#region src/js/utils/tiktokModals.js
const tiktokModals = () => {
	const links = document.querySelectorAll(["a[href*=\"tiktok.com\"]"].join(","));
	if (links.length > 0) {
		links.forEach((link) => {
			let urlPathParts = new URL(link.getAttribute("href")).pathname.split("/video/");
			let videoId = typeof urlPathParts == "object" && urlPathParts.length > 0 ? urlPathParts[1] : false;
			if (videoId) {
				const template = `
          <div class="modal-box p-4">
            <iframe
              title="TikTok video player"
              data-src="https://www.tiktok.com/player/v1/${videoId}?loop=1&rel=0"
              width="720" height="1280" frameborder="0" loading="eager" allowfullscreen
              class="tiktok-${videoId} aspect-9/16 max-w-full h-auto"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </div>`.trim();
				const dialog = document.createElement("dialog");
				dialog.setAttribute("id", `tiktok-${videoId}`);
				dialog.setAttribute("closedby", "any");
				["modal"].map((c) => dialog.classList.add(c));
				dialog.innerHTML = template;
				document.querySelector("body").appendChild(dialog);
				link.addEventListener("click", (event) => {
					const selector = `#tiktok-${videoId}`;
					const targetModal = document.querySelector(selector);
					targetModal.showModal();
					const targetVideo = targetModal.querySelector("iframe");
					targetVideo.setAttribute("src", targetVideo.dataset.src);
					event.preventDefault();
					return false;
				});
			}
		});
		document.querySelectorAll("dialog[id^=\"tiktok-\"]").forEach((overlay) => {
			overlay.addEventListener("click", (event) => {
				document.querySelector(`#${overlay.id}`).close();
				event.preventDefault();
			});
			overlay.addEventListener("close", () => {
				document.querySelector(`iframe.${overlay.id}`).removeAttribute("src");
			});
		});
	}
};
if (window.tiktokModalOverlay) document.addEventListener("DOMContentLoaded", tiktokModals);
//#endregion
//#region src/js/utils/bodyClickCloseDetails.js
/**
* This code will cause clicks in the BODY of a page to close any open
* DETAILS/SUMMARY elements that appear in the global header (as part
* of dropdown navigation) or the collection filters (as part of Product
* filtering)
*/
const bodyClickCloseDetails = () => {
	document.querySelector("body").addEventListener("click", () => {
		const openDetailsElements = document.querySelectorAll("header#header details[open], .brindle-organism-collection-filters details[open]");
		if (openDetailsElements.length > 0) openDetailsElements.forEach((element) => {
			element.removeAttribute("open");
		});
	});
	const allDetailsElements = document.querySelectorAll("header#header details, .brindle-organism-collection-filters details");
	if (allDetailsElements.length > 0) allDetailsElements.forEach((element) => {
		element.addEventListener("click", (event) => {
			event.stopPropagation();
		});
	});
};
document.addEventListener("DOMContentLoaded", bodyClickCloseDetails);
//#endregion
//#region src/js/utils/getWindowProductData.js
/**
* Given a productId (string or int) this will return
* values saved to `window.products[]`.
*
* Valid responses return a JSON formatted Product object.
* Invalid responses return null.
*/
const getWindowProductData = (productId) => {
	const product = window.products.find((product) => product.productId === parseInt(productId));
	return product ? product.product : null;
};
const getWindowProductVariantData = (productId, variantId) => {
	const variant = getWindowProductData(productId).variants.find((variant) => variant.id === parseInt(variantId));
	return variant ? variant : null;
};
window.getWindowProductData = getWindowProductData;
window.getWindowProductVariantData = getWindowProductVariantData;
//#endregion
